import { Card, CardActions, CardContent, Grid, Typography } from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import React from "react";
import { getClickButton } from "../../functions/getButtons";
import IIntegration from "../../models/IIntegration";
import { IntegrationStatuses } from "./IntegrationStatuses";
import { FieldNameLabels, LongFieldTypography } from "./style/IntegrationStyledComponents";
import { IntegrationSystems } from "./IntegrationSystems";

interface IIntegrationDetailSummaryCardProps {
  model: IIntegration;
  setAllowEdit: (val: boolean) => void;
}

export const IntegrationDetailReadOnlySummaryCard = (props: IIntegrationDetailSummaryCardProps) => {
  const { model, setAllowEdit } = props;

  const isQmlativ = model.System.ID === IntegrationSystems.Qmlativ;
  const allowEdit = model.Status.ID === IntegrationStatuses.NotStarted || model.Status.ID === IntegrationStatuses.InDevelopment;

  return (
    <Card>
      <CardContent>
        <Grid container wrap="wrap" spacing={2}>
          <Grid item xs={4}>
            <FieldNameLabels variant="subtitle1">Status:</FieldNameLabels>
          </Grid>
          <Grid item xs={8}>
            <Typography>{model.Status.Name}</Typography>
          </Grid>
          <Grid item xs={4}>
            <FieldNameLabels variant="subtitle1">System</FieldNameLabels>
          </Grid>
          <Grid item xs={8}>
            <Typography>{model.System.Name}</Typography>
          </Grid>
          <Grid item xs={4}>
            <FieldNameLabels variant="subtitle1">Data Direction</FieldNameLabels>
          </Grid>
          <Grid item xs={8}>
            <Typography>{model.DataDirection.Name}</Typography>
          </Grid>
          {isQmlativ && (
            <>
              <Grid item xs={4}>
                <FieldNameLabels variant="subtitle1">Development URL:</FieldNameLabels>
              </Grid>
              <Grid item xs={8}>
                <Typography>{model.DevelopmentURL}</Typography>
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <FieldNameLabels variant="subtitle1">Description:</FieldNameLabels>
          </Grid>
          <Grid item xs={12}>
            <LongFieldTypography>{model.Description}</LongFieldTypography>
          </Grid>
          <Grid item xs={12}>
            <FieldNameLabels variant="subtitle1">Notes:</FieldNameLabels>
          </Grid>
          <Grid item xs={12}>
            <LongFieldTypography>{model.PublishNotes}</LongFieldTypography>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions>{allowEdit && getClickButton("Edit", <Edit />, () => setAllowEdit(true))}</CardActions>
    </Card>
  );
};
